import React, { Fragment, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Collapse,
  DialogContentText,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import PropTypes from "prop-types";

import Backdrop from "Components/Common/Backdrop";
import Modal from "Components/Common/Modal";
import FireSafetyBuildingObservation from "./FireSafetyBuildingObservation";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

import { useGetBuildingSchedulesQuery } from "apis/FireSafety/FireSafetyObservation";

const FireSafetyBuildingObservationDetails = ({
  handleClose,
  applicationId,
  buildingName,
  t,
  isObservationNoticeSend,
}) => {
  const {
    data: { data: buildingSchedulesData } = {},
    isLoading,
    isFetching,
  } = useGetBuildingSchedulesQuery(applicationId);

  const [scheduleId, setScheduleId] = useState("");

  const handleToggle = (id) => {
    if (scheduleId === id) {
      setScheduleId("");
    } else {
      setScheduleId(id);
    }
  };

  useEffect(() => {
    if (buildingSchedulesData?.length === 1) {
      setScheduleId(buildingSchedulesData[0].scheduleId);
    }
  }, [buildingSchedulesData]);

  if (isLoading || isFetching) {
    return <Backdrop open />;
  }

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      maxWidth="lg"
      title={t("Building Observations") + " - " + buildingName}
    >
      {buildingSchedulesData?.length ? (
        buildingSchedulesData.map(({ startDate, endDate, scheduleId: id }) => (
          <Fragment key={id}>
            <div
              className="fs-4 fw-semibold mb-3 border-bottom"
              onClick={() => handleToggle(id)}
              key={id}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="cursor-pointer"
              >
                <div className="d-flex align-items-center gap-1">
                  <p className="fw-bold mb-0">{`${convertUTCDateToLocalDate(
                    startDate
                  ).format("DD-MM-YYYY")} - ${convertUTCDateToLocalDate(
                    endDate
                  ).format("DD-MM-YYYY")}`}</p>
                </div>
                <IconButton>
                  {scheduleId === id ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Stack>
            </div>
            <DialogContentText variant="subtitle2" component="div">
              <Collapse in={scheduleId === id} timeout="auto" unmountOnExit>
                <>
                  <FireSafetyBuildingObservation
                    applicationId={applicationId}
                    buildingName={buildingName}
                    handleClose={handleClose}
                    scheduleId={id}
                    isObservationNoticeSend={isObservationNoticeSend}
                  />
                </>
              </Collapse>
            </DialogContentText>
          </Fragment>
        ))
      ) : (
        <Typography variant="h6" className="text-center mt-3">
          {t("There is no observations added for this building till now")}
        </Typography>
      )}
    </Modal>
  );
};

FireSafetyBuildingObservationDetails.propTypes = {
  handleClose: PropTypes.func,
  applicationId: PropTypes.number,
  buildingName: PropTypes.string,
  t: PropTypes.func,
  isObservationNoticeSend:PropTypes.bool,
};

export default withTranslation()(FireSafetyBuildingObservationDetails);
